import React from 'react';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { faqs } from './FaqsContent';

const FaqSection = () => {
    return (
        <Box id="faq" sx={{
            backgroundColor: '#fff4cb',
            py: 2,
        }}>
            <Typography variant="h4" align="center" gutterBottom sx={{ fontWeight: 'bold', mb: 4, color: 'var(--c-brand-ink)' }}>
                F.A.Q
            </Typography>

            {faqs.map((faq, index) => (
                <Accordion 
                    key={index} 
                    sx={{
                        width: '100%', 
                        maxWidth: { xs: '90%', md: '600px', sm: '600px' }, 
                        mx: 'auto', 
                        boxShadow: 3,
                        mb: 2,
                        py: 1,
                        overflow: 'hidden',
                        '&:before': { display: 'none' },
                        borderRadius: '16px !important',
                        '&.Mui-expanded': {
                            borderRadius: '16px !important',
                            mb: 2,
                            mx: 'auto'
                        },
                        '&:first-of-type': {
                            borderRadius: '16px 16px 16px 16px !important',
                            '&.Mui-expanded': {
                                borderRadius: '16px 16px 16px 16px !important'
                            }
                        },
                        '&:last-of-type': {
                            borderRadius: '16px 16px 16px 16px !important',
                            '&.Mui-expanded': {
                                borderRadius: '16px 16px 16px 16px !important'
                            }
                        },
                    }}
                >
                    <AccordionSummary 
                        expandIcon={<ExpandMoreIcon />}
                        sx={{
                            borderRadius: '16px',
                            '&.Mui-expanded': {
                                borderRadius: '16px 16px 0 0',
                                borderBottom: '1px solid #e0e0e0'
                            }
                        }}
                    >
                        <Typography sx={{
                            color: 'var(--c-brand-ink)', 
                            fontWeight: 'bold'
                        }}>{faq.question}</Typography>
                    </AccordionSummary>
                    <AccordionDetails
                        sx={{
                            borderRadius: '0 0 16px 16px',
                            backgroundColor: '#f8f8f8'
                        }}
                    >
                        <Typography color="text.secondary">{faq.answer}</Typography>
                    </AccordionDetails>
                </Accordion>
            ))}
        </Box>
    );
};

export default FaqSection;